import { createAction, props } from '@ngrx/store';
import { CourseDetails } from './course.model';

export const CourseDetailsActions = {
  // All QNA Group By Date
  loadCourseDetails: createAction('[Course Details] Load Course Details', props<{ slug: string }>()),
  loadCourseDetailsSuccess: createAction('[Course Details] Load Course Details Success', props<CourseDetails>()),
  loadCourseDetailsFail: createAction('[Course Details] Load Course Details Fail', props<{ error: unknown }>()),
};
